export const langConstants = {
  CHANGE_LANG: "CHANGE_LANG",
};
